export const noThumbnailAvailable = 'none';

export type CategoryStatus = 'incomplete' | 'submitted';
